module.exports = __webpack_public_path__ + "static/media/36peixeboi.9e98428a.mp3";